export async function consumeImportSseResponse(response, onProgress) {
    if (!response.ok) {
        let message = `Import failed (${response.status})`;
        try {
            const body = await response.json();
            message = body.message || message;
        } catch (_err) {
            try {
                message = await response.text() || message;
            } catch (_textErr) {
                // keep default message
            }
        }
        throw new Error(message);
    }

    if (!response.body) {
        throw new Error('Streaming import is not supported by this browser');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let finalEvent = null;

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split('\n\n');
        buffer = parts.pop() || '';

        for (const part of parts) {
            const line = part.split('\n').find((entry) => entry.startsWith('data: '));
            if (!line) continue;
            const event = JSON.parse(line.slice(6));
            onProgress?.(event);
            if (event.phase === 'done' || event.phase === 'error') {
                finalEvent = event;
            }
        }
    }

    return finalEvent;
}

export function describeImportProgress(event) {
    if (!event) return { label: 'Importing...', detail: '' };

    if (event.phase === 'reading') {
        return { label: 'Reading spreadsheet...', detail: '' };
    }
    if (event.phase === 'parsing') {
        return {
            label: `Validating rows ${event.processed || 0}/${event.total || 0}`,
            detail: event.skipped ? `${event.skipped} skipped so far` : '',
        };
    }
    if (event.phase === 'inserting') {
        return {
            label: `Saving events ${event.processed || 0}/${event.total || 0}`,
            detail: `${event.inserted || 0} inserted${event.failed ? `, ${event.failed} failed` : ''}`,
        };
    }
    if (event.phase === 'done') {
        return { label: 'Import complete', detail: event.message || '' };
    }
    if (event.phase === 'error') {
        return { label: 'Import failed', detail: event.message || '' };
    }
    return { label: 'Importing...', detail: event.message || '' };
}
